<template>
	<div>
		<div v-if="lista.length > 0">
			<div class="row" v-for="(item, index) in lista" :key="index">
				<div class="col-xs-4">
					<label>{{ _traducao('global', 'motivo') }}:</label><br />
					{{ item.justificativa_solicitacao }}
				</div>
				<div class="col-xs-2">
					<label>{{ _traducao('global', 'status') }}:</label><br />
					<span class="text-info" v-if="item.status == 'E'">EM ANÁLISE</span>
					<span class="text-success" v-if="item.status == 'A'">APROVADA</span>
					<span class="text-danger" v-if="item.status == 'N'">NEGADA</span>
					<span class="text-danger" v-if="item.status == 'C'">CANCELADA</span>
					<span class="text-success" v-if="item.status == 'F'">FINALIZADO</span>

					<div style="margin-top: 4px" v-if="item.status == 'N'">
						<i class="fa fa-fw fa-info-circle" v-tooltip="'Motivo da negativa'"></i>
						{{ item.justificativa_resposta }}
					</div>
				</div>

				<div class="col-xs-2">
					<label>{{ _traducao('global', 'solicitante') }}:</label><br />
					{{ item.nome_usuario_solicitacao }}
				</div>
				<div class="col-xs-2">
					<label>{{ _traducao('global', 'diarioDeBordo') }}:</label><br />
					{{ item.numero_diario }}
				</div>
				<div class="col-xs-2">
					<label>{{ _traducao('global', 'solicitadoEm') }}:</label><br />
					{{ item.data_solicitacao | dataTempo }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		lista: {
			type: Array,
			required: true,
			default: () => []
		}
	},

	data() {
		return {}
	},

	methods() {}
}
</script>